import { t } from "../../i18n";
import { Download } from "lucide-react";
import type { PreviewAsset } from "./GameAssetPreview.types";

export function GameAssetLinks({ asset }: { asset: PreviewAsset }) {
  if (!asset.url) return null;
  return (
    <div className="mt-2 flex gap-2 text-xs">
      <a
        className="button gap-1 px-2 py-1"
        href={asset.url}
        target="_blank"
        rel="noreferrer"
      >
        {t("Open")}
      </a>
      <a className="button gap-1 px-2 py-1" href={asset.url} download>
        <Download size={13} /> {t("Download")}
      </a>
    </div>
  );
}
